var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tile is-ancestor is-parent" },
    [
      _c("div", { staticClass: "tile is-parent is-vertical detail-width" }, [
        _c(
          "article",
          { staticClass: "tile is-child box" },
          [
            _c("div", { staticClass: "columns is-gapless" }, [
              _c("div", { staticClass: "column" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v("Order Receipt Detail "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.innerValue.isNew,
                          expression: "!innerValue.isNew",
                        },
                      ],
                      staticClass: "icon has-text-info tooltip is-tooltip-info",
                      class: [_vm.canChangeReadOnly ? "readonly-pointer" : ""],
                      attrs: {
                        "data-tooltip": _vm.readOnlyView
                          ? "Invoice is locked"
                          : "Invoice is unlocked",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toogleReadOnly()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "icon mdi",
                        class: [
                          _vm.readOnlyView
                            ? "mdi-lock-outline"
                            : "mdi-lock-open-outline",
                        ],
                      }),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "control is-pulled-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button tooltip is-tooltip-topright ml-2",
                      attrs: {
                        "data-tooltip": "Back to order receipt listing",
                      },
                      on: { click: _vm.backToListing },
                    },
                    [_vm._m(0)]
                  ),
                ]),
                _vm.isLockPurchaseOrder
                  ? _c("div", [_c("order-lock-notification")], 1)
                  : _vm._e(),
              ]),
            ]),
            _vm.activeItems
              ? _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": 1,
                      "page-size": 100,
                      "total-rows": _vm.activeItems.length,
                      "show-pagination": false,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.sortColumn,
                      "sort-order": _vm.sortOrder,
                    },
                    on: { sort: _vm.sort },
                  },
                  [
                    _vm._l(_vm.activeItems, function (item, index) {
                      return _c(
                        "tr",
                        {
                          key: item.invoiceId,
                          class: { "is-selected": _vm.selectedRow === index },
                        },
                        [
                          _c("td", { staticClass: "has-vertical-middle" }, [
                            _vm._v(_vm._s(item.itemNo)),
                          ]),
                          _c("td", { staticClass: "has-vertical-middle" }, [
                            _vm._v(_vm._s(item.description)),
                          ]),
                          _c(
                            "td",
                            {
                              staticClass:
                                "has-vertical-middle has-text-centered",
                            },
                            [_vm._v(_vm._s(item.side))]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "has-vertical-middle has-text-right",
                            },
                            [_vm._v(_vm._s(item.owning))]
                          ),
                          _c(
                            "td",
                            { staticClass: "has-vertical-middle partno-input" },
                            [
                              (item.itemType === "PART" ||
                                item.itemType === "OTHER") &&
                              !_vm.readOnlyView
                                ? _c("div", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.partNo,
                                          expression: "item.partNo",
                                        },
                                      ],
                                      staticClass: "input",
                                      attrs: {
                                        placeholder: "Part No",
                                        disabled: _vm.isLockPurchaseOrder,
                                      },
                                      domProps: { value: item.partNo },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            item,
                                            "partNo",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ])
                                : _c("div", [_vm._v(_vm._s(item.partNo))]),
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticClass:
                                "has-vertical-middle has-text-right money-input",
                            },
                            [
                              !_vm.readOnlyView
                                ? _c("vue-numeric", {
                                    staticClass: "input has-text-right",
                                    attrs: {
                                      disabled: _vm.isLockPurchaseOrder,
                                      min: 0,
                                      precision: 2,
                                    },
                                    model: {
                                      value: item.unitCost,
                                      callback: function ($$v) {
                                        _vm.$set(item, "unitCost", _vm._n($$v))
                                      },
                                      expression: "item.unitCost",
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          item.unitCost,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass:
                                "has-vertical-middle has-text-right quantity-input",
                            },
                            [
                              !_vm.readOnlyView
                                ? _c("vue-numeric", {
                                    staticClass: "input has-text-right",
                                    attrs: {
                                      min: 0,
                                      disabled: _vm.isLockPurchaseOrder,
                                      precision: 0,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.checkRecQty(item)
                                      },
                                    },
                                    model: {
                                      value: item.received,
                                      callback: function ($$v) {
                                        _vm.$set(item, "received", _vm._n($$v))
                                      },
                                      expression: "item.received",
                                    },
                                  })
                                : _c("span", [_vm._v(_vm._s(item.received))]),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass:
                                "has-vertical-middle has-text-right money-input",
                            },
                            [
                              !_vm.readOnlyView
                                ? _c("vue-numeric", {
                                    staticClass: "input has-text-right",
                                    attrs: {
                                      min: 0,
                                      disabled: _vm.isLockPurchaseOrder,
                                      precision: 2,
                                    },
                                    nativeOn: {
                                      input: function ($event) {
                                        return _vm.updateBeforeGst(item)
                                      },
                                    },
                                    model: {
                                      value: item.dealerCost,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "dealerCost",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "item.dealerCost",
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          item.dealerCost,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass:
                                "has-vertical-middle has-text-right money-input",
                            },
                            [
                              !_vm.readOnlyView
                                ? _c("vue-numeric", {
                                    staticClass: "input has-text-right",
                                    attrs: {
                                      min: 0,
                                      disabled: _vm.isLockPurchaseOrder,
                                      precision: 2,
                                    },
                                    nativeOn: {
                                      input: function ($event) {
                                        return _vm.updateAfterGst(item)
                                      },
                                    },
                                    model: {
                                      value: item.totalAmount,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "totalAmount",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "item.totalAmount",
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          item.totalAmount,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass:
                                "has-vertical-middle has-text-right gst-input",
                            },
                            [
                              !_vm.readOnlyView
                                ? _c("vue-numeric", {
                                    staticClass: "input has-text-right",
                                    attrs: {
                                      min: 0,
                                      disabled: _vm.isLockPurchaseOrder,
                                      precision: 2,
                                    },
                                    nativeOn: {
                                      input: function ($event) {
                                        return _vm.checkGst(item)
                                      },
                                    },
                                    model: {
                                      value: item.gstAmount,
                                      callback: function ($$v) {
                                        _vm.$set(item, "gstAmount", _vm._n($$v))
                                      },
                                      expression: "item.gstAmount",
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          item.gstAmount,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "has-vertical-middle account-input",
                            },
                            [
                              !_vm.readOnlyView
                                ? _c(
                                    "div",
                                    [
                                      _vm.glAccountListCombo &&
                                      _vm.selectedItemAccounts.length > 0
                                        ? _c(
                                            "multiselect",
                                            {
                                              attrs: {
                                                options: _vm.glAccountListCombo,
                                                placeholder: "Select account",
                                                label: "displayName",
                                                "track-by": "accountNo",
                                                "deselect-label":
                                                  "Can't remove this value",
                                                "show-labels": false,
                                                "allow-empty": false,
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedItemAccounts[
                                                    index
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedItemAccounts,
                                                    index,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedItemAccounts[index]",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "has-text-danger",
                                                  attrs: { slot: "noResult" },
                                                  slot: "noResult",
                                                },
                                                [
                                                  _vm._v(
                                                    "G/L account not found."
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      _vm.glAccountListCombo &&
                                      _vm.selectedItemAccounts.length > 0
                                        ? _c("multiselect", {
                                            attrs: {
                                              options: _vm.glAccountListCombo,
                                              placeholder: "Select account",
                                              label: "displayName",
                                              "track-by": "accountNo",
                                              "deselect-label":
                                                "Can't remove this value",
                                              "show-labels": false,
                                              "allow-empty": false,
                                              disabled: true,
                                            },
                                            model: {
                                              value:
                                                _vm.selectedItemAccounts[index],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.selectedItemAccounts,
                                                  index,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "selectedItemAccounts[index]",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                            ]
                          ),
                        ]
                      )
                    }),
                    _c("template", { slot: "footer" }, [
                      _c(
                        "tr",
                        {
                          staticClass: "no-border",
                          class: `purchase-order-background-success-${_vm.$theme.name}`,
                        },
                        [
                          _c(
                            "th",
                            {
                              staticClass: "has-text-left",
                              attrs: { colspan: _vm.columns.length - 4 },
                            },
                            [
                              _vm.totalReceiptQty === 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "icon has-text-danger tooltip is-tooltip-danger",
                                      attrs: {
                                        "data-tooltip":
                                          "You have not received any items.",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "mdi mdi-alert mdi-18px",
                                      }),
                                    ]
                                  )
                                : _vm.receiptEntity.totalAmount === 0 &&
                                  _vm.receiptEntity.overrideIncGst === 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "icon has-text-danger tooltip is-tooltip-danger is-tooltip-multiline",
                                      attrs: {
                                        "data-tooltip":
                                          "Amount for received item or an Override Amount cannot be zero!",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "mdi mdi-alert mdi-18px",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" Totals "),
                            ]
                          ),
                          _c("th", { staticClass: "has-text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.totalBeforeGst,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("th", { staticClass: "has-text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.totalAfterGst,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("th", { staticClass: "has-text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.totalGst,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("th", { attrs: { colspan: "1" } }),
                        ]
                      ),
                    ]),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                            _vm._v("receiptEntity "),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _c("div", { staticClass: "is-divider" }),
            _c("div", { staticClass: "columns is-gapless" }, [
              _vm._m(1),
              _c("div", { staticClass: "column" }, [
                !_vm.readOnlyView &&
                _vm.receiptEntity.receiptItems &&
                _vm.receiptEntity.receiptItems.length > 0
                  ? _c(
                      "form",
                      {
                        ref: "uploader",
                        attrs: {
                          enctype: "multipart/form-data",
                          novalidate: "",
                        },
                      },
                      [
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "div",
                            { staticClass: "file is-pulled-right is-primary" },
                            [
                              _c("label", { staticClass: "file-label" }, [
                                _c("input", {
                                  staticClass: "file-input",
                                  attrs: {
                                    type: "file",
                                    name: _vm.uploadFieldName,
                                    disabled: _vm.isSaving || _vm.readOnlyView,
                                    accept: "image/png, image/jpeg, .pdf",
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.filesChange(
                                        $event.target.name,
                                        $event.target.files
                                      )
                                      _vm.fileCount = $event.target.files.length
                                    },
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "file-cta",
                                    class: `has-file-btn-text-${_vm.$theme.name}`,
                                  },
                                  [
                                    _vm._m(2),
                                    _c("span", { staticClass: "file-label" }, [
                                      _vm._v(" Select files... "),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _c(
              "bulma-table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
                attrs: {
                  columns: _vm.attachmentsColumns,
                  "page-index": 1,
                  "page-size": 100,
                  "total-rows": _vm.attachments.length,
                  "show-pagination": false,
                  "is-loading": _vm.isTableLoading,
                  "sort-column": _vm.sortColumn,
                  "sort-order": _vm.sortOrder,
                },
                on: { sort: _vm.sort },
              },
              [
                _vm._l(_vm.attachments, function (item, index) {
                  return _c(
                    "tr",
                    {
                      key: item.id,
                      class: { "is-selected": _vm.selectedRow === index },
                    },
                    [
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatDateTimeLocale(
                              item.createdDate,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "has-vertical-middle" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadAttachment(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.fileName))]
                        ),
                      ]),
                      _c("td", [_vm._v(_vm._s(item.fileSize))]),
                      _c(
                        "td",
                        {
                          staticClass:
                            "has-vertical-middle has-text-centered is-content-width",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-danger is-small is-inverted",
                              attrs: {
                                disabled:
                                  _vm.readOnlyView ||
                                  _vm.receiptEntity.receiptItems.length === 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteAttachment(item)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon is-medium" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-delete mdi-24px",
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                _c("template", { slot: "empty" }, [
                  _c("section", { staticClass: "section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "content has-text-grey has-text-centered",
                      },
                      [
                        _c("span", { attrs: { icon: "icon is-large" } }, [
                          _c("i", {
                            staticClass: "mdi mdi-48px mdi-emoticon-sad",
                          }),
                        ]),
                        _c("p", [_vm._v("Nothing")]),
                      ]
                    ),
                  ]),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "tile is-parent is-vertical is-2" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _c("div", { staticClass: "field is-narrow" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Invoice Number")]),
            !_vm.readOnlyView &&
            ((_vm.receiptEntity.isNew &&
              _vm.receiptEntity.receiptItems &&
              _vm.receiptEntity.receiptItems.length > 0) ||
              (_vm.$userInfo.isSupportUser && !_vm.receiptEntity.exported))
              ? _c("div", { staticClass: "control is-narrow" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.receiptEntity.invoiceNo,
                        expression: "receiptEntity.invoiceNo",
                      },
                    ],
                    staticClass: "input",
                    class: {
                      "is-danger":
                        !_vm.receiptEntity.isValid && _vm.invoiceError !== null,
                    },
                    attrs: { maxlength: 100, type: "text", placeholder: "" },
                    domProps: { value: _vm.receiptEntity.invoiceNo },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.receiptEntity,
                            "invoiceNo",
                            $event.target.value
                          )
                        },
                        function ($event) {
                          return _vm.checkInvoiceNoExists(_vm.receiptEntity)
                        },
                      ],
                    },
                  }),
                  !_vm.receiptEntity.isValid && _vm.invoiceError !== null
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v(_vm._s(_vm.invoiceError)),
                      ])
                    : _vm._e(),
                ])
              : _c("div", [
                  _c("span", [
                    _vm._v(_vm._s(_vm.receiptEntity.invoiceNo) + " "),
                  ]),
                ]),
          ]),
          _c(
            "div",
            { staticClass: "field is-narrow" },
            [
              _c("label", { staticClass: "label" }, [_vm._v("Date")]),
              !_vm.readOnlyView &&
              _vm.receiptEntity.receiptItems &&
              _vm.receiptEntity.receiptItems.length > 0
                ? _c("v-date-picker", {
                    attrs: {
                      "is-dark": _vm.$theme.isDark,
                      masks: _vm.formats,
                      attributes: _vm.attrs,
                      locale: _vm.$userInfo.locale,
                      "min-date": _vm.firstDayOfMonth,
                      timezone: _vm.$filters.getIanaTimezone(),
                    },
                    on: {
                      input: function ($event) {
                        _vm.selectedInvoiceDate =
                          _vm.$filters.fromISOWithCurrentTime(
                            $event.toISOString()
                          )
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c("div", { staticClass: "field" }, [
                                _c(
                                  "div",
                                  { staticClass: "control has-icons-left" },
                                  [
                                    _c(
                                      "input",
                                      _vm._g(
                                        {
                                          staticClass: "input",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Invoice Date",
                                            readonly: "",
                                          },
                                          domProps: { value: inputValue },
                                        },
                                        inputEvents
                                      )
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small is-left" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-calendar mdi-18px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1467311795
                    ),
                    model: {
                      value: _vm.selectedInvoiceDate,
                      callback: function ($$v) {
                        _vm.selectedInvoiceDate = $$v
                      },
                      expression: "selectedInvoiceDate",
                    },
                  })
                : _c("span", [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.$filters.formatDateTimezone(
                          _vm.selectedInvoiceDate,
                          _vm.$userInfo.locale
                        ),
                      },
                    }),
                  ]),
            ],
            1
          ),
          _c("div", { staticClass: "field is-narrow" }, [
            _c("label", { staticClass: "label" }, [_vm._v("ABN")]),
            !_vm.readOnlyView &&
            _vm.receiptEntity.receiptItems &&
            _vm.receiptEntity.receiptItems.length > 0
              ? _c(
                  "div",
                  { staticClass: "control has-icons-right" },
                  [
                    _vm.$company.info.countryCode === "AU"
                      ? _c("the-mask", {
                          ref: "abn",
                          staticClass: "input abn",
                          class: {
                            "is-danger":
                              _vm.receiptEntity.abn &&
                              _vm.$v.entity.orderReceipts.$each[_vm.idx].abn
                                .$error,
                          },
                          attrs: {
                            id: "abn",
                            name: "abn",
                            placeholder: "ABN",
                            mask: ["## ### ### ###"],
                          },
                          model: {
                            value: _vm.receiptEntity.abn,
                            callback: function ($$v) {
                              _vm.$set(_vm.receiptEntity, "abn", $$v)
                            },
                            expression: "receiptEntity.abn",
                          },
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.receiptEntity.abn,
                              expression: "receiptEntity.abn",
                            },
                          ],
                          ref: "abn",
                          staticClass: "input is-uppercase",
                          attrs: { id: "abn", maxlength: "12" },
                          domProps: { value: _vm.receiptEntity.abn },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.receiptEntity,
                                "abn",
                                $event.target.value
                              )
                            },
                          },
                        }),
                    _vm.receiptEntity.abn &&
                    !_vm.$v.entity.orderReceipts.$error &&
                    _vm.$v.entity.orderReceipts.$each[_vm.idx].abn.validAbn &&
                    _vm.$v.entity.orderReceipts.$each[_vm.idx].abn.minLength &&
                    _vm.$company.info.countryCode === "AU"
                      ? _c(
                          "span",
                          { staticClass: "icon has-text-success is-right" },
                          [_c("i", { staticClass: "mdi mdi-check mdi-18px" })]
                        )
                      : _vm._e(),
                    _vm.receiptEntity.abn &&
                    _vm.$v.entity &&
                    !_vm.$v.entity.orderReceipts.$each[_vm.idx].abn.minLength
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v(
                            "ABN must be " +
                              _vm._s(
                                _vm.$v.entity.orderReceipts.$each[_vm.idx].abn
                                  .$params.minLength.min
                              ) +
                              " digits."
                          ),
                        ])
                      : _vm.receiptEntity.abn &&
                        _vm.$v.entity &&
                        !_vm.$v.entity.orderReceipts.$each[_vm.idx].abn.validAbn
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("ABN format is invalid."),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.receiptEntity.abn))]),
                ]),
          ]),
          _c("div", { staticClass: "field is-narrow" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Total Amt. (Incl GST)"),
            ]),
            _c(
              "div",
              { staticClass: "control" },
              [
                !_vm.readOnlyView &&
                _vm.receiptEntity.receiptItems &&
                _vm.receiptEntity.receiptItems.length > 0
                  ? _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      attrs: { type: "text", placeholder: "", precision: 2 },
                      nativeOn: {
                        input: function ($event) {
                          return _vm.updateOverrideTotal(_vm.receiptEntity)
                        },
                      },
                      model: {
                        value: _vm.receiptEntity.overrideIncGst,
                        callback: function ($$v) {
                          _vm.$set(_vm.receiptEntity, "overrideIncGst", $$v)
                        },
                        expression: "receiptEntity.overrideIncGst",
                      },
                    })
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.receiptEntity.overrideIncGst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "field is-narrow" }, [
            _c("label", { staticClass: "label" }, [_vm._v("GST")]),
            _c(
              "div",
              { staticClass: "control" },
              [
                !_vm.readOnlyView &&
                _vm.receiptEntity.receiptItems &&
                _vm.receiptEntity.receiptItems.length > 0
                  ? _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      attrs: { type: "text", placeholder: "", precision: 2 },
                      nativeOn: {
                        input: function ($event) {
                          return _vm.checkOverrideGst(_vm.receiptEntity)
                        },
                      },
                      model: {
                        value: _vm.receiptEntity.overrideGst,
                        callback: function ($$v) {
                          _vm.$set(_vm.receiptEntity, "overrideGst", $$v)
                        },
                        expression: "receiptEntity.overrideGst",
                      },
                    })
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.receiptEntity.overrideGst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
              ],
              1
            ),
          ]),
          _vm.receiptEntity.overrideIncGst != _vm.totalAfterGst
            ? _c("div", { staticClass: "field is-narrow" }, [
                _c("span", { staticClass: "has-text-danger" }, [
                  _vm._v(
                    "Rounding Inv. Amt. " +
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.receiptEntity.overrideIncGst - _vm.totalAfterGst,
                          _vm.$userInfo.locale
                        )
                      )
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "field is-narrow" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Exported")]),
            _c(
              "div",
              { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.receiptEntity.exported,
                      expression: "receiptEntity.exported",
                    },
                  ],
                  attrs: {
                    id: "chk-invoice-exported",
                    name: "chk-invoice-exported",
                    type: "checkbox",
                    disabled: _vm.readOnlyView || !_vm.$userInfo.isSupportUser,
                  },
                  domProps: {
                    checked: Array.isArray(_vm.receiptEntity.exported)
                      ? _vm._i(_vm.receiptEntity.exported, null) > -1
                      : _vm.receiptEntity.exported,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.receiptEntity.exported,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.receiptEntity,
                              "exported",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.receiptEntity,
                              "exported",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.receiptEntity, "exported", $$c)
                      }
                    },
                  },
                }),
                _vm._m(3),
              ]
            ),
          ]),
        ]),
      ]),
      _vm.currentAttachment
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.confirmDelete(true)
                },
                cancel: function ($event) {
                  return _vm.confirmDelete(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Attachment"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(_vm.currentAttachment.fileName))]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-chevron-double-left mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v(" Attachments ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "file-icon" }, [
      _c("i", { staticClass: "mdi mdi-upload mdi-20px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Exported")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }